// Cross-app link + canonical configuration.
// Override via env vars for production/staging.
export const LOCATION_APP_URL =
  process.env.REACT_APP_LOCATION_URL ||
  "https://location.reliancefashionfactorystores.com";
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  "https://reliancefashionfactorystores.com";
